import { render, staticRenderFns } from "./inspectionPointList.vue?vue&type=template&id=24a1bc94&scoped=true"
import script from "./inspectionPointList.vue?vue&type=script&lang=js"
export * from "./inspectionPointList.vue?vue&type=script&lang=js"
import style0 from "./inspectionPointList.vue?vue&type=style&index=0&id=24a1bc94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a1bc94",
  null
  
)

export default component.exports